import styled from "styled-components";

export const DatePickerWrapper = styled.div`
	display: flex;
	min-width: 160px;
	width: 100%;
	height: 40px;
	min-width: 160px;
	width: 100%;
	justify-content: space-between;
	align-items: center;
	align-self: stretch;
	border-radius: 20px;
	font-size: 10px;
	font-weight: 500;
	line-height: 12px;
	letter-spacing: 0.3px;
`;

export const DatePickerButtonWrapper = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	height: 40px;
	max-width: 360px;
	padding: 0 10px 0 15px;
	gap: 5px;
	border-radius: 25px;
	background: rgba(0, 0, 0, 0.9);
`;

export const Date = styled.div`
	color: var(--secondary-text-color);
	text-align: center;
	font-size: 12px;
	font-weight: 400;
	line-height: 20px;
	letter-spacing: 0.3px;
`;

export const DatePickerContentWrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	width: 100%;
	height: 100%;
`;

export const DateTitle = styled.div`
	color: var(--content-text-color);
	text-align: center;
	font-size: 14px;
	font-weight: 400;
	line-height: 20px;
	letter-spacing: 0.75px;
`;
